

























import './KisweSlider.scss'
import { defineComponent } from '@vue/composition-api'
import { Slider } from 'element-ui'
import { useFlexbox, useThemes, useSizes } from '../../compositions'
import { generateRandomString } from '@/modules/common/utils'
import { KisweTheme } from '../../types'

export default defineComponent({
  name: 'KisweSlider',
  components: {
    'el-slider': Slider
  },
  props: {
    value: {
      type: [Number, Array as () => number[]],
      required: true
    },
    label: {
      type: String as () => string|null,
      required: false,
      default: null
    },
    vertical: {
      type: Boolean,
      required: false,
      default: false
    },
    min: {
      type: Number,
      required: false,
      default: 0
    },
    max: {
      type: Number,
      required: false,
      default: 100
    },
    range: {
      type: Boolean,
      required: false,
      default: false
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    showTooltip: {
      type: Boolean,
      required: false,
      default: false
    },
    formatTooltip: {
      type: Function as () => Function|null,
      required: false,
      default: null
    },
    ...useFlexbox().props,
    ...useThemes({ theme: KisweTheme.Primary }).props,
    ...useSizes().props
  },
  emits: {
    input (_value: number|number[]) { return true }
  },
  data: () => ({
    id: `kiswe-slider--${ generateRandomString(12, false) }`
  }),
  computed: {
    val: {
      get (): number|number[] {
        return this.value
      },
      set (val: number|number[]) {
        if (val === this.value) return
        this.$emit('input', val)
      }
    }
  }
})
